
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ObservatoryService, UserService } from '@services/services.module';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  activeRequests = 0;

  constructor(
    private observatory: ObservatoryService,
    private user_service: UserService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.activeRequests) {
      // check if is info end-point to not have a lot loaders active
      // because when we go back  on distribuidora view, the loader actives and desactive several times
      if (request.url.includes('/ess/v1/user/info')) {
        this.observatory.setData('loader', false);
      } else {
        this.observatory.setData('loader', true);
      }
    }

    this.activeRequests++;
    return next.handle(request).pipe(
      finalize(() => {
        this.activeRequests--;
        if (!this.activeRequests) {
          this.observatory.setData('loader', false);
        }
      })
    );

  }

}
